/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
'use strict';

/*
 * Polyfills loaded: HTML Imports, Custom Elements, Shady DOM/Shady CSS, platform polyfills, template
 * Used in: IE 11
 */

import '../bower_components/webcomponents-platform/webcomponents-platform.js'
import '../bower_components/template/template.js'
import '../bower_components/es6-promise/dist/es6-promise.auto.min.js'
import '../bower_components/html-imports/src/html-imports.js'
import '../src/pre-polyfill.js'
import '../bower_components/shadydom/src/shadydom.js'
import '../bower_components/custom-elements/src/custom-elements.js'
import '../bower_components/shadycss/entrypoints/scoping-shim.js'
import '../src/post-polyfill.js'
import '../src/unresolved.js'
